import { render } from "./RestaurantStatsToday.vue?vue&type=template&id=1b6a7d18&scoped=true&ts=true"
import script from "./RestaurantStatsToday.vue?vue&type=script&lang=ts"
export * from "./RestaurantStatsToday.vue?vue&type=script&lang=ts"

import "./RestaurantStatsToday.vue?vue&type=style&index=0&id=1b6a7d18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6a7d18"]])

export default __exports__